import { render, staticRenderFns } from "./step.vue?vue&type=template&id=fa23529e&scoped=true"
import script from "./step.vue?vue&type=script&lang=js"
export * from "./step.vue?vue&type=script&lang=js"
import style0 from "./step.vue?vue&type=style&index=0&id=fa23529e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa23529e",
  null
  
)

export default component.exports